import type {RouteRecordRaw} from 'vue-router';
import {propositionGuard} from '@/router/guards/propositionGuard';

export const subscriptionRoutes: RouteRecordRaw[] = [
  {
    name: 'subscriptions.index',
    path: '/subscriptions',
    component: () => import('@/views/Subscriptions/SubscriptionsIndex.vue'),
    meta: {
      permissions: ['selectSubscription'],
      title: (t) => t('subscriptions.title', 2),
    },
    children: [
      {
        path: '',
        name: 'subscription-overview',
        components: {
          subscriptions: () => import('@/views/Subscriptions/Overview/Overview.vue'),
        },
      },
      {
        path: 'packages',
        name: 'subscriptions-bundles',
        beforeEnter: (to, from) => {
          propositionGuard(to, from, (proposition) => {
            return proposition.subscriptions.bundle.enabled;
          });
        },
        components: {
          subscriptions: () => import('@/views/Subscriptions/Bundles/Bundles.vue'),
        },
      },
      {
        path: 'my-contracts',
        name: 'subscriptions-my-contracts',
        beforeEnter: (to, from) => {
          propositionGuard(to, from, (proposition) => {
            return proposition.subscriptions.myContracts.enabled;
          });
        },
        components: {
          subscriptions: () => import('@/views/Subscriptions/MyContracts/MyContracts.vue'),
        },
      },
      {
        path: 'my-analytics',
        name: 'subscriptions-my-analytics',
        beforeEnter: (to, from) => {
          propositionGuard(to, from, (proposition) => {
            return proposition.subscriptions.myAnalytics.enabled;
          });
        },
        components: {
          subscriptions: () => import('@/views/Subscriptions/MyAnalytics/MyAnalytics.vue'),
        },
      },
      {
        path: 'my-orders',
        name: 'subscriptions-my-orders',
        beforeEnter: (to, from) => {
          propositionGuard(to, from, (proposition) => {
            return proposition.subscriptions.myOrders.enabled;
          });
        },
        components: {
          subscriptions: () => import('@/views/Subscriptions/MyOrders/MyOrders.vue'),
        },
      },
      {
        path: 'my-scan-and-print',
        name: 'subscriptions-my-scan-and-print',
        beforeEnter: (to, from) => {
          propositionGuard(to, from, (proposition) => {
            return proposition.subscriptions.myScanAndPrint.enabled;
          });
        },
        components: {
          subscriptions: () => import('@/views/Subscriptions/MyScanAndPrint/MyScanAndPrint.vue'),
        },
      },
      {
        path: 'my-returns',
        name: 'subscriptions-my-returns',
        beforeEnter: (to, from) => {
          propositionGuard(to, from, (proposition) => {
            return proposition.subscriptions.myReturns.enabled;
          });
        },
        components: {
          subscriptions: () => import('@/views/Subscriptions/MyReturns/MyReturns.vue'),
        },
      },
    ],
  },
];
